import React from "react";

import {useQuery} from "@tanstack/react-query";
import cx from "classnames";

import {EventOrigin, recordEvent} from "@globals/config/eventUtils";
import {DateString} from "@globals/types/utilityTypes";

import styles from "./ImageBanner.scss";
import {getBanner} from "./ImageBanner.service";
import {BannerImageItem, ImageBannerName} from "./intefaces";

export default function ImageBanner({
  name,
  date,
  containerClassName,
  locationId,
}: {
  name: ImageBannerName;
  date: DateString;
  containerClassName?: string;
  locationId?: number;
}): JSX.Element {
  const {data: banner} = useQuery({
    queryKey: [`banner-image-${name}`, date, locationId],
    queryFn: () => getBanner(name, date, locationId),
  });

  const onBannerClick = () => {
    recordEvent(EventOrigin.PAGE, "clicked promo banner", banner?.id);
  };

  if (!banner) {
    return <></>;
  }

  const ImageBannerContainer = banner.href ? "a" : "div";

  const bannerClassNames = cx(
    !banner.image && styles.textBanner,
    containerClassName,
    styles.imageBanner
  );
  const mobileBannerClassNames = cx(
    !banner.mobile_image && styles.textBanner,
    containerClassName,
    styles.mobileImageBanner
  );

  const renderBanner = (
    src: string | null,
    banner: BannerImageItem,
    classNames: string
  ) => {
    if (!src && !banner.text) {
      return null;
    }

    return (
      <ImageBannerContainer
        onClick={onBannerClick}
        className={classNames}
        href={banner.href || undefined}
        data-testid={`image-banner-${banner.id}`}
      >
        {src ? <img src={src} alt={banner.text} /> : <span>{banner.text}</span>}
      </ImageBannerContainer>
    );
  };

  return (
    <>
      {renderBanner(banner.image, banner, bannerClassNames)}
      {renderBanner(banner.mobile_image, banner, mobileBannerClassNames)}
    </>
  );
}
